function navigateToAnchor(id, customOffset = 0) {
    const target = document.getElementById(id);
    if (!target) return;

    const rootStyles = getComputedStyle(document.documentElement);

    const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height')) || 0;

    const breadcrumbsHeight = parseInt(rootStyles.getPropertyValue('--breadcrumbs-height')) || 0;

    const y = target.getBoundingClientRect().top + window.scrollY - headerHeight - breadcrumbsHeight - customOffset;

    history.pushState(null, '', `#${id}`);
    window.scrollTo({ top: y, behavior: 'smooth' });
}

export function pickYourPlatformCards() {
    $('.pick-your-platforms').each(function () {
        const section = this;
        const transitionCard = section.querySelector('.card[data-card-expended]');
        const smallContent = transitionCard.querySelector('.content-for-small');
        const fullWidthContent = transitionCard.querySelector('.content-for-full-width');
        const cardsToRemove = section.querySelectorAll('.card.small:not([data-card-expended])');

        let state = transitionCard.dataset.cardExpended == 'true';
        const threshold = innerHeight / 4;
        const duration = +transitionCard.dataset.animationDuration;

        let lastSwitchTime = 0;
        const timeBuffer = 200; // Prevents jittering unfinished animation

        const switchState = (newState) => {
            transitionCard.dataset.cardExpended = newState;

            cardsToRemove.forEach((card) => {
                if (newState) {
                    card.classList.add('opacity-0');
                    setTimeout(() => {
                        card.hidden = true;
                    }, duration);
                } else {
                    card.hidden = false;
                    setTimeout(() => {
                        card.classList.remove('opacity-0');
                    }, duration * 2.5);
                }
            });

            if (newState) {
                smallContent.classList.add('opacity-0');

                setTimeout(() => {
                    transitionCard.classList.toggle('small');
                    transitionCard.classList.toggle('full-width');
                    fullWidthContent.classList.remove('opacity-0');
                }, duration);
            } else {
                fullWidthContent.classList.add('opacity-0');

                setTimeout(() => {
                    transitionCard.classList.toggle('small');
                    transitionCard.classList.toggle('full-width');
                    smallContent.classList.remove('opacity-0');
                }, duration);
            }

            state = newState;
            lastSwitchTime = Date.now();
        };

        addEventListener('scroll', function () {
            if (innerWidth < 1000) return;
            if (Date.now() - lastSwitchTime < timeBuffer) return;

            const y = transitionCard.getBoundingClientRect().y;
            const hysteresisBuffer = 100; // Buffer to prevent flickering

            if (y < threshold && !state) switchState(true);
            // Add buffer: must scroll UP significantly past the threshold to trigger collapse
            if (y > threshold + hysteresisBuffer && state) switchState(false);
        });

        const fullWidthCards = Array.from(section.querySelectorAll('.card.full-width:not(.mobile-only), [data-card-expended]'));

        fullWidthCards.forEach((card, i) => {
            card.style.top = `calc(var(--header-height) + var(--breadcrumbs-height) + 24px + ((28px + 40px) * ${i}))`;
        });

        if (fullWidthCards.length > 1) {
            const cardsWithTitleIcons = Array.from(fullWidthCards).slice(0, -1);

            window.addEventListener('scroll', () => {
                if (innerWidth < 1000) return;

                cardsWithTitleIcons.forEach((card, i) => {
                    const stickyTop = parseFloat(window.getComputedStyle(card).top);
                    const currentTop = card.getBoundingClientRect().top;
                    const stickyBuffer = 10; // Buffer to prevent jitter
                    const isSticky = card.classList.contains('is-sticky');

                    // If currently sticky, wait until we are well past the threshold to unstick (hysteresis)
                    if (isSticky) {
                        if (currentTop > stickyTop + 1 + stickyBuffer) {
                            card.classList.remove('is-sticky');
                        }
                    } else {
                        // If not sticky, stick immediately when reaching threshold
                        if (currentTop <= stickyTop + 1) {
                            card.classList.add('is-sticky');
                        }
                    }
                });

                const lastCard = fullWidthCards[fullWidthCards.length - 1];
                const lastCardStickyTop = parseFloat(window.getComputedStyle(lastCard).top);
                const lastCardCurrentTop = lastCard.getBoundingClientRect().top;
                const isLastCardSticky = lastCardCurrentTop <= lastCardStickyTop + 1;
                lastCard.classList.toggle('in-view', isLastCardSticky);
            });

            cardsWithTitleIcons.forEach((card) => {
                card.addEventListener('click', (e) => {
                    if (e.target.closest('a, button')) return;

                    const anchor = card.dataset.anchor;
                    if (!anchor) return;

                    const offset = parseInt(card.dataset.anchorOffset || '0', 10);

                    navigateToAnchor(anchor, offset);
                });
            });
        }
    });
}
